import React, { FC, useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Logo from "../../components/Logo";
import offlogo from "../../assets/logos/offlogo.svg";

interface IBrandProps {
  asideStatus: boolean;
  setAsideStatus: (status: boolean) => void;
}

const Brand: FC<IBrandProps> = ({ asideStatus, setAsideStatus }) => {
  // useEffect(() => {
  //   console.log("Brand clicked......", asideStatus);
  // }, [asideStatus]);

  return (
    <div className="brand">
      <div className="brand-logo">
        <h1 className="brand-title">
          <Logo height={32} />
          {/* <Link to="/dashboard" aria-label="Logo">
            <Logo height={32} />
          </Link> */}
        </h1>
      </div>

      {!asideStatus && (
        <img
          src={offlogo}
          alt="Toggle Aside"
          className="brand-aside-toggle-icon"
        />
      )}
    </div>
  );
};

Brand.propTypes = {
  asideStatus: PropTypes.bool.isRequired,
  setAsideStatus: PropTypes.func.isRequired,
};

export default Brand;
